import { useLocation, useNavigate } from 'react-router-dom';
import { IRowData, MenuActionIds, useAppDispatch } from '../../../../base';
import { JobStatus } from '../../../../common';
import { jobsActions } from '../../../../actions';
import { RoutePaths } from '../../../../routes/RoutePaths';

export const useTableCallbacks = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const onRowClick = (item: IRowData) => {
        const existingQueryParams = new URLSearchParams(location.search);
        navigate(`${item?.data?.id}?${existingQueryParams.toString()}`);
    };
    const onChangeStatus = (id: number, status: JobStatus) => {
        const updateJobActionPayload = {
            jobId: String(id),
            status,
        };
        if (
            status === JobStatus.Closed ||
            status === JobStatus.Canceled ||
            status === JobStatus.Completed
        ) {
            dispatch(
                jobsActions.setCancelOrCloseJob({
                    jobId: String(id),
                    status,
                })
            );
            dispatch(jobsActions.setConfirmJobCloseOrCancelModalOpen(true));
        } else {
            dispatch(jobsActions.updateJobStatus(updateJobActionPayload));
        }
    };

    const onEdit = (cellId: number) => {
        navigate(`${RoutePaths.jobs}/${cellId}${RoutePaths.saveJob}`);
    };

    const onClone = (cellId: number) => {
        dispatch(jobsActions.setActiveJob({ job: null }));
        navigate(`${RoutePaths.jobs}${RoutePaths.saveJob}?clone=${cellId}`);
    };

    const onDeleteJob = (cellId: number) => {
        dispatch(jobsActions.deleteJob({ jobId: String(cellId) }));
    };

    const onMenuItemClick = (
        cellId: number,
        _row: Record<string, string> | undefined,
        actionId: string | undefined
    ) => {
        switch (actionId) {
            case MenuActionIds.Publish:
                onChangeStatus(cellId, JobStatus.Published);
                break;
            case MenuActionIds.Edit:
                onEdit(cellId);
                break;
            case MenuActionIds.Resume:
                onChangeStatus(cellId, JobStatus.Published);
                break;
            case MenuActionIds.Suspend:
                onChangeStatus(cellId, JobStatus.Suspended);
                break;
            case MenuActionIds.Clone:
                onClone(cellId);
                break;
            case MenuActionIds.Cancel:
                onChangeStatus(cellId, JobStatus.Canceled);
                break;
            case MenuActionIds.Complete:
                onChangeStatus(cellId, JobStatus.Completed);
                break;
            case MenuActionIds.Delete:
                onDeleteJob(cellId);
                break;
            default:
                break;
        }
    };

    return { onRowClick, onMenuItemClick };
};
